import { TrialPromoOfferCreated } from 'app/design/icons/trial-promo-offer-created';
import { TrialPromoOfferMissing } from 'app/design/icons/trial-promo-offer-missing';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Trans, useTranslation } from 'react-i18next';
import type { FreeSubParams } from './free-sub';

export function FreeSubPendingOfferProgress({
  numOffersCreated,
  offersCreated,
  userGotFreeSub,
}: {
  numOffersCreated: number | false | undefined;
  offersCreated: string[];
  userGotFreeSub: FreeSubParams['userGotFreeSub'];
}) {
  const { t } = useTranslation('free-sub');
  if (userGotFreeSub || !numOffersCreated) return null;

  return (
    <Column
      alignItems="center"
      gap="spacing.general.x8"
      style={{ marginHorizontal: 40, marginTop: -10, marginBottom: -10 }}
    >
      <Text style={{ fontSize: 18, textAlign: 'center' }} variant="bodyBase">
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          i18nKey="subscriptionNotYetActivatedText"
          ns="free-sub"
        />
      </Text>
      <Row
        alignItems="center"
        alignSelf="center"
        flexWrap="wrap"
        gap="spacing.general.x2"
        style={{ justifyContent: 'center' }}
      >
        {offersCreated.map((idx) => (
          <TrialPromoOfferCreated key={idx} />
        ))}
        {numOffersCreated < 1 ? <TrialPromoOfferMissing /> : undefined}
        {numOffersCreated < 2 ? <TrialPromoOfferMissing /> : undefined}
        {numOffersCreated < 3 ? <TrialPromoOfferMissing /> : undefined}
        {numOffersCreated < 4 ? <TrialPromoOfferMissing /> : undefined}
        {numOffersCreated < 5 ? <TrialPromoOfferMissing /> : undefined}
      </Row>
      <Text fontSize={18} lineHeight={22} marginHorizontal="spacing.general.x2" textAlign="center">
        {t(`numCreated${numOffersCreated <= 1 ? numOffersCreated.toFixed(0) : ''}`, {
          numOffersCreated,
          ns: 'trialPromo',
        })}
      </Text>
    </Column>
  );
}
